<template>
  <div class="darkbg" @click="changePage('')"></div>
  <div class="loginpage mobile-modal-takeover" v-if="!loginsuccess">
    <div class="log-box">
      <div class="e-log-box">
        <div class="block">
          <div class="row" style="flex-direction: row">
            <div class="left_c title" style="justify-content: left; width: 90%">
              <span v-if="parent == 'refer'" style="font-size:1.625rem">
                <span v-html="t('login.earnPoints')"></span>
                <!--   Log in, share your code, and eamn <span style="color: #4ca771">100 Points!</span> -->
              </span>
              <span v-else>
                {{ t('login.logIn') }}</span>
            </div>
            <div class="right_c title" style="width: 10%" @click="closeWin()" v-if="hideClose != 1">
              <img src="/images/icon_close.png" style="width: 19px; height: 19px; object-fit: cover" />
            </div>
          </div>
        </div>
        <div v-if="error != ''" class="error">
          <WarningIcon />
          {{ error }}
        </div>
        <div v-if="success != ''" class="success">{{ success }}</div>

        <el-form ref="rieForms" label-position="top" label-width="auto" autocomplete="off" :model="loginForm"
          :rules="rules">
          <div class="tab-box">
            <div class="tab-name" style="width: 100%">{{ t('common.email') }} <span class="star">*</span></div>
          </div>
          <el-form-item label="" style="width: 100%" prop="email">
            <el-input v-model="loginForm.email" :disabled="submitting" :placeholder="t('common.email')"></el-input>
          </el-form-item>

          <div class="tab-box">
            <div class="tab-name" style="width: 100%">{{ t('common.password') }} <span class="star">*</span></div>
          </div>
          <el-form-item label="" style="width: 100%" prop="password">
            <el-input :disabled="submitting" v-model="loginForm.password" :placeholder="t('common.password')"
              show-password></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="block forgrt-box" style="width: 100%; margin-top: 15px">
        <div class="r" style="padding-left: 0px">
          <div class="left_c">
          </div>
          <div class="right_c" style="width:100%">
            <div style="color: #4ca771" @click="changePage('recoverpass')"
              v-if="parent != 'agent' && parent != 'refer'">
              {{ t('login.forgotPassword') }}
            </div>
          </div>
        </div>
      </div>

      <div v-gtag:click="'customer_login'" :class="loginForm.email == '' && loginForm.password == ''
        ? 'btn-box Opacity1'
        : 'btn-box Opacity1'
        " @click="logsubmit">
        <svg v-if="submitting" xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 24 24">
          <g transform="rotate(-23 12 12)">
            <circle cx="18" cy="12" r="0" fill="currentColor">
              <animate attributeName="r" begin=".67" calcMode="spline" dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite"
                values="0;2;0;0" />
            </circle>
            <circle cx="12" cy="12" r="0" fill="currentColor">
              <animate attributeName="r" begin=".33" calcMode="spline" dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite"
                values="0;2;0;0" />
            </circle>
            <circle cx="6" cy="12" r="0" fill="currentColor">
              <animate attributeName="r" begin="0" calcMode="spline" dur="1.5s"
                keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite"
                values="0;2;0;0" />
            </circle>
          </g>
        </svg>
        <div v-else>
          {{ t('login.logIn') }}
        </div>
      </div>
      <div class="yy-box" @click="changePage('register')" v-if="parent != 'agent'">
        {{ t('login.dontHave') }}
        <span style="padding-left: 5px">{{ t('login.createAnAccount') }}</span>
      </div>
    </div>
  </div>
  <div v-else>
    <AlertDialog @closeWin="closeWin()" status="success" :title="t('login.success')"
      :content="t('login.successDesc')" />
  </div>
</template>
<script>
//import Request from '@/services/Request'
import { computed } from "vue";
import AlertDialog from '@/components/alertdialog.vue'
import { Warning as WarningIcon } from '@element-plus/icons-vue'
import { useUserStore } from '@/stores/UserStore'
import '@/assets/main.css'
import vGtag from '@/directives/GtagDirective'
import { useI18n } from 'vue-i18n';
import { localDriver } from '@/utils/localDriver'

export default {
  components: { AlertDialog, WarningIcon },
  directives: { gtag: vGtag },
  props: {
    parent: {
      type: [String],
      default: ''
    },
    hideClose: {
      type: Number,
      default: 0,
    },
  },
  emits: ['changePage', 'setLogin', 'close'],
  setup() {
    const { t, locale } = useI18n();
    const userStore = useUserStore()
    const user = userStore.user;
    const rules = computed(() => ({
      password: [{ required: true, message: t("common.cantEmpty"), trigger: "blur" }],
      email: [
        { required: true, message: t("common.cantEmpty"), trigger: "blur" },
        { pattern: /^\s*\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+\s*$/, message: t('common.enterEmail'), trigger: "blur" }
      ]
    }));
    return { userStore, user, t, locale, rules }
  },
  data() {
    return {
      login_need: false,
      findpassworderror: '',
      findpasswordresucess: '',
      logintype: '',
      loginWindow: false,
      resWindow: false,
      logoutWindow: false,
      isLogin: false,
      rieForm: {
        agree: false,
        firstname: '',
        telephone: '',
        lastname: '',
        email: '',
        smsCode: '',
        password: '',
        confirm: '',
        Birth: '',
        Gender: ''
      },
      loginForm: {
        email: '',
        password: '',
        remember: false
      },
      flag: '',
      usdvalue: '',
      homecurrency: [],
      options2: [],
      navList: [],
      navIndex: 0,
      indexData: ['', '', ''],
      props: {
        label: 'title',
        value: 'item',
        expandTrigger: 'hover'
      },
      dialogVisible2: false,
      checked: true,
      command: 'b',
      email: '',
      input2: '',
      password: '',
      dialogVisible: false,

      dropdownStatus: {
        Destinations: false,
        TripStyles: false,
        Stories: false,
        Deals: false,
        country: false
      },

      options: [],
      smsPlaceholder: 'sms code',
      code: '',
      smsTitle: 'Send',
      sendclick: false,
      submitting: false,
      showBtn: true,
      second: 60,
      error: '',
      success: '',
      loginsuccess: false
    }
  },
  created() { },
  methods: {
    rememberMe() {
      this.loginForm.remember = !this.loginForm.remember
    },
    changePage(page) {
      if (this.submitting) {
        return
      }
      if (page == "register") {
        this.userStore.showLoginDlg = 'register'
      }
      else if (page == "login") {
        this.userStore.showLoginDlg = 'login'
      }
      else if (page == "recoverpass") {
        this.userStore.showLoginDlg = 'recoverpass'
      }
      //  this.$emit('changePage', page)
    },
    closeWin() {
      if (this.submitting) {
        return
      }
      this.$emit('close', '') // 当点击关闭按钮时，触发close事件
    },
    parseQueryString(url) {
      const queryString = url.split('?')[1]
      const params = {}
      if (queryString) {
        queryString.split('&').forEach((pair) => {
          var [key, value] = pair.split('=')
          key = key == 'route' ? 'url' : key
          params[decodeURIComponent(key)] = decodeURIComponent(value)
        })
      }
      return params
    },
    async logsubmit() {
      this.formvalidater().then(async (isFormCompleted) => {
        if (this.submitting) {
          return
        }
        if (!isFormCompleted) {
          return
        }
        if (this.loginForm.remember) this.loginForm.rem = '1'
        else this.loginForm.rem = '0'
        this.success = ''
        this.error = ''
        this.submitting = true
        let succ = false
        try {
          succ = await this.userStore.login(this.loginForm)
        }
        finally {
          this.submitting = false
        }

        if (succ) {
          this.$emit('setLogin');
          this.isLogin = true
          this.loginsuccess = true
        }
        else {
          this.error = "";
          this.userStore.serverErrors.forEach(e => {
            this.error += e
          })
        }
      })
    },
    formvalidater() {
      return new Promise((resolve, reject) => {
        this.$refs.rieForms.validate((valid) => {
          if (!valid) {
            resolve(false) // 或者使用 reject() 来表示验证失败
          } else {
            resolve(true)
          }
        })
      })
    }
  }
}
</script>



<style lang="scss" scoped>
/* Email and password fields: no dark border, outline or focus ring on the wrapper or the inner input.
   :deep is needed because Element Plus renders the inputs inside its own component. */
:deep(.el-input .el-input__wrapper),
:deep(.el-input .el-input__wrapper.is-focus.is-focus),
:deep(.el-input .el-input__wrapper.is-error),
:deep(.el-input .el-input__wrapper:focus-within) {
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
}
:deep(.el-input__inner),
:deep(.el-input__inner:focus),
:deep(.el-input__inner:focus-visible) {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}
.error {
  svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
}

.title {
  font-size: 17px;
  font-weight: bold;
}

.checkbox {
  background: #fff;
  width: 16px;
  height: 16px;
  border: 1px #ccc solid;
  border-radius: 3px;
  cursor: pointer;
  font-size: 1.4083rem;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.agree {
  background: #00f1bd;
  border: 1px #00f1bd solid;
  font-size: 1.4083rem;
}

.noagree {
  background: #fff;
  border: 1px #4f6f52 solid;
}

.red-placeholder ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: red !important;
  opacity: 1;
  /* Firefox */
}

.red-placeholder :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: red !important;
}

.red-placeholder ::-ms-input-placeholder {
  /* Microsoft Edge */
  color: red !important;
}

.el-divider--horizontal {
  width: 60% !important;
  margin: 0 auto;
}

.log-success-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 813rpx;
  height: 782rpx;
  flex-shrink: 0;
  border-radius: 33px;
  border-radius: 33px;
  background: #fff;
  z-index: 99;
}

:deel(.el-dialog) {
  top: -75px;
  border-radius: 33px;

  .el-dialog__header {
    font-weight: bold;
    border: 0px solid red;
    padding-top: 30px;
    text-align: center;

    .el-dialog__headerbtn {
      font-size: 2.8167rem;
      font-weight: 700;
      color: #000;
    }
  }
}

* {
  padding: 0;
}

.el-select-dropdown__item {
  padding: 0 20px;
}

.log-box {
  .yy-box {
    text-align: center;
    margin-top: 8px;

    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #a6a6a6;

    span {
      color: #4ca771;
      cursor: pointer;
    }
  }

  .btn-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
    width: 100%;
    height: 48px;

    border-radius: 8px;
    opacity: 1;
    font-size: 1.7333rem;

    font-weight: bold;
    color: #fff;
    cursor: pointer;
  }

  .Opacity1 {
    background: rgba(0, 241, 189, 1);
    color: rgba(51, 51, 51);
  }

  .Opacity05 {
    background: rgba(0, 241, 189, 0.5);
    color: rgba(51, 51, 51, 0.5);
  }

  .forgrt-box {
    line-height: 20px;
  }

  :deep(.e-log-box) {
    .el-form {
      .el-form-item {
        vertical-align: middle;
        width: 50%;
        margin: 0;
        padding: 0px;
        border: 0px solid red;

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          width: 100%;

          line-height: 48px;

          .el-date-editor--date {
            width: 100%;
          }

          .el-select {
            width: 100%;
          }

          .input-with-select {
            border: 2rpx solid #e9e9eb;
            border-radius: 99rpx;
            padding: 8rpx 14rpx 8rpx 0;

            &.el-input .el-input__inner {
              border: none;
              height: 48px;
              line-height: 48px;
              padding-left: 10px;

              &::placeholder {
                color: #cfcfcf;
              }
            }

            .el-input-group__append {
              border-radius: 20rpx;
              font-weight: bold;
              cursor: pointer;
            }
          }

          .el-input {
            .el-input__inner {
              color: #333;
              border-radius: 10px;
              height: 48px;
              line-height: 48px;
              border: 0px solid red;
              font-size: 1.7333rem;
              font-family: Poppins;
              background: #f5f5f5;
              padding-left: 10px;

              &::placeholder {
                color: #a6a6a6;
              }
            }

            .el-input__suffix .el-input__icon.el-icon-arrow-up {
              color: #333;
            }
          }
        }
      }

      .el-input-group__append {
        background: #4f6f52;
        border: 1px solid #4f6f52;
      }
    }
  }

  .tab-box {
    line-height: 19px;
    margin: 20px 0 6px;
    width: 50%;
    float: left;

    .star {
      color: red;
      padding-left: 5px;
    }

    .active {
      color: #4f6f52 !important;
    }

    .tab-name {
      font-size: 1.5167rem;
      font-weight: 500;
      color: #666;
      font-family: Poppins;
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.fb-btn {
  display: flex;
  margin-bottom: 10px;
  padding: 0 25px;

  div {
    flex: 1;
    height: 40px;
    border-radius: 25px;
    opacity: 1;
    border: 2px solid #a6a6a6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4083rem;
    font-family: Poppins;
    font-weight: 400;
    color: #333333;
    cursor: pointer;

    &:first-child {
      margin-right: 10px;
    }
  }
}

.primaryColor {
  color: #4f6f52;
}

.custom-checkbox .el-checkbox__inner {
  border-color: #4f6f52 !important;
}

/* 当checkbox被hover时也改变边框颜色 */
.custom-checkbox:hover .el-checkbox__inner {
  border-color: #4f6f52 !important;
}

/* 当checkbox被选中时，改变对号的颜色以适应新的边框颜色 */
.custom-checkbox.is-checked .el-checkbox__inner {
  border-color: #4f6f52 !important;
}

.custom-checkbox.is-checked .el-checkbox__inner::after {
  border-color: #4f6f52 !important;
}

:deel(.el-cascader-node.in-active-path),
:deel(.el-cascader-node.is-active),
:deel(.el-cascader-node.is-selectable.in-checked-path) {
  color: #4f6f52;
}

:deel(.el-dropdown-menu__item) {
  padding: 10rpx 20rpx;

  text-align: center;
}

:deel(.share-adventure-wrap) {
  background-color: red;
}

:deel(.el-dropdown-menu__item:hover) {
  background-color: #4f6f52;
  color: #fff;
}

:deel(.el-dropdown-menu__item:focus) {
  background-color: #4f6f52;
  color: #fff;
}

:deel(.el-dropdown-menu) {
  padding: 0 !important;
}

.el-dropdown-menu {
  padding: 0 !important;
  border-radius: 15px;
  text-align: center;
  overflow: hidden;
}

.loginpage {
  position: fixed;
  width: 468px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 32px 40px;
  /*  border: 1px solid #e5e5e5; */
  border-radius: 12px;
  z-index: 99;
  background: #fff;
  font-size: 1.7333rem;
}

.country-item {
  display: flex;
  align-items: center;

  .country-img {
    width: 20rpx;
    height: 20rpx;
  }

  .country-txt {
    font-size: 1.1917rem;
    margin-left: 3px;
  }
}

:deep(.pc_field) {
  display: block;
}

:deep(.m_field) {
  display: none;
}

:deep(.el-form-item__error) {
  font-size: 1.4rem !important;
}
</style>



<!-- 移动端 -->
<style scoped>
@media screen and (max-width: 750px) {
  :deep(.el-form-item__error) {
    font-size: 1.1rem !important;
  }

  .log-box .btn-box {
    height: 4rem;
  }

  .title span {
    font-size: 1.54rem;
  }

  .log-box .tab-box .tab-name {
    font-size: 1.3rem;
  }

  :deep(.log-box .e-log-box .el-form .el-form-item .el-form-item__content .el-input .el-input__inner) {

    height: 4rem;
    font-size: 1.4rem !important;
    line-height: 4rem;

  }

  :deep(.pc_field) {
    display: none;
  }

  :deep(.m_field) {
    display: block;
  }

  :deep(.el-date-editor.el-input),
  .el-date-editor.el-input__wrapper {
    height: 30px !important;
    font-size: 1.4083rem;
    width: 100% !important;
  }

  .tab-box {
    padding: 0px;
  }

  html,
  body {
    line-height: 19px !important;
  }

  .loginpage {
    width: 90%;
    padding: 20px;
  }
}
</style>